/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".headings[_ngcontent-%COMP%]{height:26px;font-size:18px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.44;letter-spacing:normal;color:#4a4a4a;padding:5px 30px}.values[_ngcontent-%COMP%]{max-width:265px;height:26px;font-size:15px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.73;letter-spacing:normal;color:#4a4a4a;padding:5px 30px;margin-bottom:5px}.rows[_ngcontent-%COMP%]{display:flex;padding:0 40px;align-items:center}\n/*# sourceMappingURL=card-layout.component.css.map*/"];
export { styles as styles };
